<template>
  <div class="container">
    <!-- ДОГОВАРА НЕТ -->
    <div v-if="documentStatus === 0">
      <div class="row mt-4">
        <div class="col">
          <span class="status_caption">Статус договора: </span>
          <span class="status_text">договора нет</span>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <button class="btn_type_1 w0" @click="$bvModal.show('create-contract-by-ip-modal')">
            Договор ИП
          </button>
          <!-- <button class="btn_type_1 w0 ml-2" @click="$bvModal.show('create-contract-by-sb-modal')">
            Договор СЗ
          </button> -->
        </div>
        <!-- <div class="col-3">
            </div> -->
      </div>
    </div>
    <!-- ЗАЯВКА -->
    <div v-if="documentStatus === 1">
      <div class="row mt-4">
        <div class="col">
          <span class="status_caption">Статус договора: </span>
          <span class="status_text">заявка</span>
        </div>
      </div>
      <div class="row" v-show="!signContractInAction">
        <div class="col">
          <button class="btn_type_1 w0" :class="[{disabled: isPdfLoading}]" @click="downloadUnsignedPdf" :disabled="isPdfLoading">
          {{ isPdfLoading ? 'Загрузка файла' : 'Предпросмотр договора' }}
          </button>
          <!-- <button class="btn_type_1 w0 ml-2" @click="signContract">Подписать договор</button> -->
        </div>
      </div>
    </div>
    <!-- СОГЛАСОВАН -->
    <div v-if="documentStatus === 2">
      <div class="row">
        <div class="col">
          <span class="status_caption">Статус договора: </span>
          <span class="status_text">согласован</span>
        </div>
      </div>
      <div class="row" v-show="!signContractInAction">
        <div class="col">
          <button class="btn_type_1 w0" :class="[{disabled: isPdfLoading}]" @click="downloadUnsignedPdf" :disabled="isPdfLoading">
          {{ isPdfLoading ? 'Загрузка файла' : 'Предпросмотр договора' }}
          </button>
          <button class="btn_type_1 w0 ml-2" @click="signContractStart">Подписать договор</button>
        </div>
      </div>
      <div v-show="signContractInAction">
        <div class="row mt-2 align-items-end">
          <div class="col-3 custom_input">
            <input v-model="smsCode" type="text" name="rls" id="rls" required />
            <label for="rls">{{ $t('Код из SMS') }}</label>
            <span class="clear_icon" @click="clearSMSCode()"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <button
              :class="`btn_type_1 w0 ${smsCode === '' ? 'disabled' : ''}`"
              :disabled="smsCode === ''"
              @click="sendSignSMSCode"
            >
              Подтвердить
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- ПРИОСТАНОВЛЕН -->
    <div v-if="documentStatus === 4">
      <div class="row">
        <div class="col">
          <span class="status_caption">Статус договора: </span>
          <span class="status_text">приостановлен</span>
          <button class="btn_type_1 w0 ml-4" :class="[{disabled: isPdfLoading}]" :disabled="isPdfLoading" @click="showSignedDocumentInfo">
          {{ isPdfLoading ? 'Загрузка файла' : 'Просмотр договора' }}
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-3">
          <span>Дата подписания</span>
          <date-picker
            v-model="rangeDate3"
            range-separator=" - "
            range
            @change="loadActs"
            :editable="false"
            format="DD.MM.YYYY"
            placeholder="дд.мм.гггг - дд.мм.гггг"
            value-type="YYYY-MM-DD"
            style="width: 100%"
          >
          </date-picker>
        </div>
        <div class="col-3">
          <span>Дата выплаты</span>
          <date-picker
            v-model="rangeDate2"
            range-separator=" - "
            range
            @change="loadActs"
            :editable="false"
            format="DD.MM.YYYY"
            placeholder="дд.мм.гггг - дд.мм.гггг"
            value-type="YYYY-MM-DD"
            style="width: 100%"
          >
          </date-picker>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <h2>Список актов</h2>
        </div>
      </div>
      <div class="acts_table mt-2">
        <b-table :fields="fields" :items="entries" head-variant="light" responsive outlined>
          <template v-slot:cell(sign_dte)="row">
            {{ row.item.sign_dte | localDate }}
          </template>
          <template v-slot:cell(pay_dte)="row">
            {{ row.item.pay_dte | localDate }}
          </template>
          <template v-slot:cell(info)="row">
            <button class="btn_type_1 mt-0" :ref="`pdf-btn-${row.item.act_id}`" @click="showSignedActInfo(row.item.act_id)">Просмотр акта</button>
          </template>
        </b-table>
      </div>
    </div>
    <!-- ПОДПИСАН -->
    <div v-if="documentStatus === 3">
      <div>
        <div class="row">
          <div class="col">
            <span class="status_caption">Статус договора: </span>
            <span class="status_text">подписан</span>
            <button class="btn_type_1 w0 ml-4" :class="[{disabled: isPdfLoading}]" :disabled="isPdfLoading" @click="showSignedDocumentInfo">
            {{ isPdfLoading ? 'Загрузка файла' : 'Просмотр договора' }}
            </button>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-3">
            <span>Дата подписания</span>
            <date-picker
              v-model="rangeDate3"
              range-separator=" - "
              range
              @change="loadActs"
              :editable="false"
              format="DD.MM.YYYY"
              placeholder="дд.мм.гггг - дд.мм.гггг"
              value-type="YYYY-MM-DD"
              style="width: 100%"
            >
            </date-picker>
          </div>
          <div class="col-3">
            <span>Дата выплаты</span>
            <date-picker
              v-model="rangeDate2"
              range-separator=" - "
              range
              @change="loadActs"
              :editable="false"
              format="DD.MM.YYYY"
              placeholder="дд.мм.гггг - дд.мм.гггг"
              value-type="YYYY-MM-DD"
              style="width: 100%"
            >
            </date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <span style="font-size: 30px; font-weight: bold;">Список актов</span>
            <button class="btn_type_1 w0 ml-4" @click="$bvModal.show('create-act-modal')">
              Заявка на Вывод ДС
            </button>
          </div>
        </div>
        <div class="acts_table mt-4">
          <b-table :fields="fields" :items="entries" head-variant="light" responsive outlined>
          <template v-slot:cell(sign_dte)="row">
            {{ row.item.sign_dte | localDate }}
          </template>
          <template v-slot:cell(pay_dte)="row">
            {{ row.item.pay_dte | localDate }}
          </template>
          <template v-slot:cell(info)="row">
            <button class="btn_type_1 mt-0" :ref="`pdf-btn-${row.item.act_id}`" @click="showSignedActInfo(row.item.act_id)">Просмотр акта</button>
          </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- МОДАЛКИ -->
    <!-- СОЗДАНИЕ АКТА -->
    <b-modal id="create-act-modal" size="lg" hide-footer centered title="Создание акта">
      <CreateActModal @close="closeActModal"/>
    </b-modal>
    <!-- СОЗДАНИЕ ДОГОВОРА КАК ИП -->
    <b-modal
      id="create-contract-by-ip-modal"
      size="lg"
      hide-footer
      centered
      title="Создание договора как ИП"
    >
      <ContractByIP @created="reloadPage"/>
    </b-modal>
    <!-- СОЗДАНИЕ ДОГОВОРА КАК СЗ -->
    <b-modal
      id="create-contract-by-sb-modal"
      size="lg"
      hide-footer
      centered
      title="Создание договора как СЗ"
    >
      <ContractBySB @created="reloadPage"/>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import ContractByIP from '../components/ContractByIP.vue';
import ContractBySB from '../components/ContractBySB.vue';
import CreateActModal from '../components/CreateActModal.vue';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import backAPI from '../assets/backApi';

export default {
  name: 'Documents',
  data() {
    return {
      key: 1,
      documentStatus: null,
      signContractInAction: false,
      isPdfLoading: false,
      signHash: '',
      smsCode: '',
      fields: [
        {
          key: 'act_id',
          label: 'Номер акта',
          sortable: true,
        },
        {
          key: 'sign_dte',
          label: 'Дата подписания акта',
          sortable: true,
        },
        {
          key: 'amount',
          label: 'Сумма',
          sortable: true,
          formatter(v) {
            if (v !== null) {
              const formatter = new Intl.NumberFormat('ru');
              return formatter.format(v);
            }
            return null;
          },
        },
        // {
        //     key: 'reg_id',
        //     label: 'Номер реестра',
        //     sortable: true,
        // },
        {
          key: 'pay_dte',
          label: 'Дата выплаты по акту',
          sortable: true,
        },
        {
          key: 'info',
          label: '',
        },
      ],
      entries: [],
      rangeDate: [
        this.$moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD'),
        this.$moment()
          .subtract(0, 'months')
          .endOf('month')
          .format('YYYY-MM-DD'),
      ],
      rangeDate2: [],
      rangeDate3: [
        this.$moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD'),
        this.$moment()
          .subtract(0, 'months')
          .endOf('month')
          .format('YYYY-MM-DD'),
      ],
    };
  },
  metaInfo() {
    this.setPageTitle(`${this.$t('Документы')}`);
    return {
      title: `${this.$t('ЛК Партнёра')} - ${this.$t('Документы')}`,
    };
  },
  async mounted() {
    await backAPI.get('/agent/contract-status').then(Response => {
      this.documentStatus = Response.data.status_id;
    });
    if (this.documentStatus >= 3) {
      const params = {
        params: {
          sign_beg_dte: this.rangeDate3[0] || null,
          sign_end_dte: this.rangeDate3[1] || null,
          pay_beg_dte: this.rangeDate2[0] || null,
          pay_end_dte: this.rangeDate2[1] || null,
        },
      };
      backAPI.get('/agent/act-list', params).then(Response => {
        this.entries = Response.data.entries;
      });
    }
  },
  methods: {
    loadActs() {
      const params = {
        params: {
          sign_beg_dte: this.rangeDate3[0] || null,
          sign_end_dte: this.rangeDate3[1] || null,
          pay_beg_dte: this.rangeDate2[0] || null,
          pay_end_dte: this.rangeDate2[1] || null,
        },
      };
      backAPI.get('/agent/act-list', params).then(Response => {
        this.entries = Response.data.entries;
      });
    },
    ...mapActions('currentPage', ['setPageTitle']),
    async reloadPage() {
      this.showToast('Создание договора', 'Заявка на договор отправлена', 'success');
      this.$bvModal.hide('create-contract-by-ip-modal');
      this.$bvModal.hide('create-contract-by-sb-modal');
      await backAPI.get('/agent/contract-status').then(Response => {
        this.documentStatus = Response.data.status_id;
      });
      if (this.documentStatus >= 3) {
        backAPI.get('/agent/act-list').then(Response => {
          this.entries = Response.data.entries;
        });
      }
    },
    closeActModal() {
      this.$bvModal.hide('create-act-modal');
      this.showToast('Создание акта', 'Акт успешно создан и подписан', 'success');
      if (this.documentStatus >= 3) {
        backAPI.get('/agent/act-list').then(Response => {
          this.entries = Response.data.entries;
        });
      }
    },
    async showSignedDocumentInfo() {
      this.isPdfLoading = true;
      await backAPI.get('/agent/contract-preview-signed',
        {
          responseType: 'blob',
        })
        .then(({ data }) => {
          const filename = `${this.$t('Договор')}.pdf`;
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
        this.isPdfLoading = false;
    },
    async showSignedActInfo(id) {
      this.$refs[`pdf-btn-${id}`].classList.add('disabled');
      this.$refs[`pdf-btn-${id}`].setAttribute('disabled', true);
      this.$refs[`pdf-btn-${id}`].innerHTML = 'Загрузка акта';
      await backAPI.get('/agent/act-preview-signed',
        {
          responseType: 'blob',
          params: {
            act_id: id,
          },
        })
        .then(({ data }) => {
          const filename = `${this.$t('Акт')}.pdf`;
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
        this.$refs[`pdf-btn-${id}`].classList.remove('disabled');
        this.$refs[`pdf-btn-${id}`].removeAttribute('disabled');
        this.$refs[`pdf-btn-${id}`].innerHTML = 'Просмотр акта';
    },
    async downloadUnsignedPdf() {
      this.isPdfLoading = true;
      await backAPI.get('/agent/contract-preview-unsigned',
        {
          responseType: 'blob',
        })
        .then(({ data }) => {
          const filename = `${this.$t('Договор не подписанный')}.pdf`;
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
        this.isPdfLoading = false;
    },
    async signContractStart() {
      const { data } = await backAPI.post('/agent/contract-sign-start').catch(error => {
        this.showToast(this.$t('Дарение баллов'), error.response.data.detail, 'danger');
      });
      this.signHash = data;
      this.signContractInAction = true;
    },
    clearSMSCode() {
      this.smsCode = '';
    },
    async sendSignSMSCode() {
      const params = {
        sms_code: this.smsCode,
        hash_content: this.signHash,
      };
      await backAPI.post('/agent/contract-sign-end', params);
      this.signContractInAction = false;
      this.smsCode = '';
      this.$bvModal.hide('create-contract-by-ip-modal');
      this.$bvModal.hide('create-contract-by-sb-modal');
      await backAPI.get('/agent/contract-status').then(Response => {
        this.documentStatus = Response.data.status_id;
      });
      if (this.documentStatus >= 3) {
        backAPI.get('/agent/act-list').then(Response => {
          this.entries = Response.data.entries;
        });
      }
    },
    showToast(title, message, status) {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      // Increment the toast count
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        h('strong', { class: 'mr-2' }, message),
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, title)],
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: status,
      });
    },
  },
  components: {
    CreateActModal,
    ContractByIP,
    ContractBySB,
    DatePicker,
  },
};
</script>

<style lang="scss" scoped>
.caption div {
  display: inline-block;
  padding: 0;
  margin: 0;

  & span {
    font-size: 20px;
  }

  & > span:last-of-type {
    display: inline-block;
    margin-left: 5px;
  }

  &:last-of-type {
    margin-left: 15px;
  }
}

.status_caption {
  font-size: 30px;
  font-weight: bold;
  color: rgb(121, 121, 121);
}

.status_text {
  font-size: 30px;
  font-weight: bold;
}
</style>
<style>
.acts_table .table td {
  vertical-align: middle !important;
}
</style>
